var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkAreaVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_134_8977",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.538086,
    y: 0.176758,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_134_8977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5381 21.1768C14.9881 21.1768 14.5174 20.9811 14.1261 20.5898C13.7341 20.1978 13.5381 19.7268 13.5381 19.1768V5.17676C13.5381 4.62676 13.7341 4.15576 14.1261 3.76376C14.5174 3.37242 14.9881 3.17676 15.5381 3.17676H19.5381C20.0881 3.17676 20.5591 3.37242 20.9511 3.76376C21.3424 4.15576 21.5381 4.62676 21.5381 5.17676V19.1768C21.5381 19.7268 21.3424 20.1978 20.9511 20.5898C20.5591 20.9811 20.0881 21.1768 19.5381 21.1768H15.5381ZM15.5381 5.17676V19.1768H19.5381V5.17676H15.5381ZM5.53809 21.1768C4.98809 21.1768 4.51709 20.9811 4.12509 20.5898C3.73375 20.1978 3.53809 19.7268 3.53809 19.1768V5.17676C3.53809 4.62676 3.73375 4.15576 4.12509 3.76376C4.51709 3.37242 4.98809 3.17676 5.53809 3.17676H9.53809C10.0881 3.17676 10.5591 3.37242 10.9511 3.76376C11.3424 4.15576 11.5381 4.62676 11.5381 5.17676V19.1768C11.5381 19.7268 11.3424 20.1978 10.9511 20.5898C10.5591 20.9811 10.0881 21.1768 9.53809 21.1768H5.53809ZM5.53809 5.17676V19.1768H9.53809V5.17676H5.53809Z",
    fill: "#ADB5BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAreaVertical);
export default __webpack_public_path__ + "static/media/bookmark_area_vertical.5d565b490e262036282ad5ed8e7c9d86.svg";
export { ForwardRef as ReactComponent };